import Service from './Service';

class PecasService extends Service {
    async recuperarPecasPorProcesso(sessao, idProcesso) {
        let pecas = await this.getPecasApi().recuperarPecasPorProcesso(sessao, idProcesso);
        pecas = pecas.sort(
            (peca1, peca2) =>
                parseInt(peca2.tipoDocumento.split(' - ')[0], 10) - parseInt(peca1.tipoDocumento.split(' - ')[0], 10)
        );
        return pecas;
    }
}
export default PecasService;
